import React, { useEffect, useState } from "react";

const skillItems = [
  {
    name: "HTML5",
    description: "Semantic structure for accessible and well-organized pages.",
    usedIn: "Used in portfolio sections and project page layouts.",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 3h16l-1.45 16.24L12 21l-6.55-1.76L4 3zm3.02 3.28L7.45 18.1 12 19.3l4.54-1.2.42-4.72H9.5l-.12-1.43h7.7l.3-3.3H9.08l-.11-1.37h8.52l.13-1.62H7.02z" />
      </svg>
    ),
  },
  {
    name: "CSS3",
    description: "Modern styling, layout, and animation for polished UI.",
    usedIn: "Used to build responsive UI, cards, sections, and hover effects.",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 3h16l-1.45 16.24L12 21l-6.55-1.76L4 3zm3.12 3.28l.22 2.48h6.6l-.22 2.56H7.56l.2 2.35h5.76l-.2 2.45-1.32.36-1.3-.35-.08-.94H8.28l.16 2 3.56.98 3.6-.97.5-5.86H9.45l-.12-1.37h6.89l.11-1.34H7.12z" />
      </svg>
    ),
  },
  {
    name: "JavaScript",
    description: "Interactive behavior and dynamic experiences for web apps.",
    usedIn: "Used for UI interactions, state-driven rendering, and logic.",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 3h18v18H3V3zm10.22 14.35c.54.9 1.24 1.55 2.74 1.55 1.4 0 2.3-.7 2.3-1.92 0-1.34-.98-1.8-2.63-2.52l-.9-.39c-2.1-.9-3.04-2-3.04-3.96 0-1.97 1.5-3.47 3.84-3.47 1.68 0 2.9.58 3.77 2.13l-2.07 1.33c-.45-.8-.94-1.1-1.7-1.1-.77 0-1.26.49-1.26 1.1 0 .77.49 1.08 1.63 1.57l.9.39c2.47 1.06 3.42 2.16 3.42 4.16 0 2.38-1.87 3.68-4.37 3.68-2.45 0-4.03-1.17-4.8-2.7l2.17-1.25zm-4.2.24c.4.7.76 1.3 1.62 1.3.83 0 1.35-.33 1.35-1.6V6.84h2.5v10.49c0 3.18-1.86 4.62-4.57 4.62-2.45 0-3.86-1.27-4.58-2.8l2.18-1.31z" />
      </svg>
    ),
  },
  {
    name: "ReactJS",
    description: "Component-based frontend development with reusable UI pieces.",
    usedIn: "Used to build this resume app with reusable components.",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 14.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4zm0 1.7c-1.08 0-2.1-.13-3.03-.35-.22.73-.31 1.4-.24 1.9.12.88.45 1.44.85 1.67.4.23 1.05.2 1.84-.24.22-.12.44-.27.67-.45.23.18.45.33.67.45.79.44 1.44.47 1.84.24.4-.23.73-.79.85-1.67.07-.5-.02-1.17-.24-1.9-.93.22-1.95.35-3.03.35zm-4.92-1.07c-.62-.26-1.17-.55-1.61-.86-.77-.54-1.18-1.07-1.18-1.54 0-.47.41-1 1.18-1.54.44-.31.99-.6 1.61-.86.33-.73.73-1.4 1.19-1.98-.45-.52-.83-1.01-1.09-1.45-.43-.74-.58-1.35-.4-1.75.18-.4.72-.76 1.58-.91.5-.09 1.18-.1 1.95-.03.57-.46 1.16-.85 1.77-1.15.86-.43 1.58-.58 2.03-.33.45.26.76.91.84 1.84.04.5.02 1.07-.07 1.68.64.41 1.24.89 1.79 1.44.55.55 1.03 1.15 1.44 1.79.61-.09 1.18-.11 1.68-.07.93.08 1.58.39 1.84.84.25.45.1 1.17-.33 2.03-.3.61-.69 1.2-1.15 1.77.07.77.06 1.45-.03 1.95-.15.86-.51 1.4-.91 1.58-.4.18-1.01.03-1.75-.4-.44-.26-.93-.64-1.45-1.09-.58.46-1.25.86-1.98 1.19z" />
      </svg>
    ),
  },
  {
    name: "Bootstarp",
    description: "Utility classes and components for faster UI development.",
    usedIn: "Used during learning and small practice interfaces.",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 5.75A1.75 1.75 0 0 1 5.75 4h12.5A1.75 1.75 0 0 1 20 5.75v12.5A1.75 1.75 0 0 1 18.25 20H5.75A1.75 1.75 0 0 1 4 18.25V5.75zm6.1 2.75v7.12h3.64c1.86 0 3.16-.96 3.16-2.46 0-1.09-.6-1.86-1.74-2.17.84-.32 1.31-.97 1.31-1.9 0-1.35-1.09-2.12-2.9-2.12H10.1zm2.22 1.71h1.07c.84 0 1.3.33 1.3.95 0 .66-.5 1.02-1.4 1.02h-.97v-1.97zm0 3.52h1.26c1 0 1.53.37 1.53 1.11 0 .74-.52 1.12-1.52 1.12h-1.27v-2.23z" />
      </svg>
    ),
  },
  {
    name: "Responsive Design",
    description: "Layouts that adapt cleanly across desktop, tablet, and mobile.",
    usedIn: "Applied across sections to ensure mobile and desktop usability.",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h8A2.5 2.5 0 0 1 17 5.5v7a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 4 12.5v-7zm3 13h10v1.5H7V18.5zM18 7h2.5A1.5 1.5 0 0 1 22 8.5v10a1.5 1.5 0 0 1-1.5 1.5H18V7z" />
      </svg>
    ),
  },
  {
    name: "GitHub",
    description: "Version control and collaboration workflows using repositories.",
    usedIn: "Used for source control, version history, and deployment workflow.",
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 .8a11.2 11.2 0 0 0-3.54 21.83c.56.1.76-.24.76-.54v-1.9c-3.1.67-3.75-1.32-3.75-1.32-.5-1.28-1.24-1.62-1.24-1.62-1.01-.69.08-.68.08-.68 1.12.08 1.7 1.15 1.7 1.15.99 1.7 2.6 1.21 3.23.92.1-.72.39-1.21.7-1.49-2.47-.28-5.06-1.24-5.06-5.52 0-1.22.44-2.22 1.15-3-.11-.28-.5-1.42.11-2.96 0 0 .95-.3 3.1 1.15a10.8 10.8 0 0 1 5.64 0c2.15-1.45 3.1-1.15 3.1-1.15.61 1.54.22 2.68.11 2.96.72.78 1.15 1.78 1.15 3 0 4.3-2.6 5.24-5.09 5.51.4.35.75 1.03.75 2.09v3.09c0 .3.2.65.77.54A11.2 11.2 0 0 0 12 .8z" />
      </svg>
    ),
  },
];

function MySkills() {
  const [activeSkill, setActiveSkill] = useState(null);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setActiveSkill(null);
      }
    };

    window.addEventListener("keydown", handleEscape);

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, []);

  const closeModal = () => setActiveSkill(null);
  const selectedSkill = skillItems.find((skill) => skill.name === activeSkill);

  return (
    <div id="skills">
      <h2>Skills</h2>
      <div className="skills-list">
        {skillItems.map((skill) => (
          <button
            key={skill.name}
            type="button"
            className="skill-card"
            onClick={() => setActiveSkill(skill.name)}
            aria-label={`${skill.name} skill`}
          >
            <span className="skill-icon">{skill.icon}</span>
            <span className="skill-name">{skill.name}</span>
          </button>
        ))}
      </div>

      {selectedSkill && (
        <div className="skill-modal-overlay" onClick={closeModal}>
          <div
            className="skill-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="skill-modal-title"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className="skill-modal-close"
              onClick={closeModal}
              aria-label="Close skill details"
            >
              x
            </button>
            <div className="skill-modal-icon">{selectedSkill.icon}</div>
            <h3 id="skill-modal-title">{selectedSkill.name}</h3>
            <p>{selectedSkill.description}</p>
            <p className="skill-used-in">
              <strong>Used in:</strong> {selectedSkill.usedIn}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default MySkills;
